var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"container ignore login"},[_vm._v(" 模拟登录页 url中需要传入token ")])}
var staticRenderFns = []

export { render, staticRenderFns }